import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import hash from 'object-hash'

import { AudienceRuleGroup } from 'organisms/AudienceRuleGroup'

class InnerAudienceRuleForm extends React.Component {
  state = {
    andRules: this.props.rules.filter(R.propEq('operator', 'and')) || [],
    orRules: this.props.rules.filter(R.propEq('operator', 'or')) || [],
  }

  setStateAndCallOnchange = (state) => {
    this.setState(state, () => {
      const rules = this.state.andRules.concat(this.state.orRules)

      const newRules = rules.map((item) => {
        return convertStateAudienceRule(item)
      })
      this.props.onChange(newRules)
    })
  }

  render() {
    const { fields, rules } = this.props
    return (
      <React.Fragment>
        <h4>Meet ALL of the following rules</h4>
        <AudienceRuleGroup
          namePrefix="and"
          fields={fields}
          operator="and"
          rules={rules.filter(R.propEq('operator', 'and'))}
          onChange={(rules) =>
            this.setStateAndCallOnchange({
              andRules: rules,
            })
          }
          shouldShowAutocomplete={this.props.shouldShowAutocomplete}
          shouldEnableFourComparison={this.props.shouldEnableFourComparison}
        />
        <h4>Meet ANY of the following rules</h4>
        <AudienceRuleGroup
          namePrefix="or"
          fields={fields}
          operator="or"
          rules={rules.filter(R.propEq('operator', 'or'))}
          onChange={(rules) =>
            this.setStateAndCallOnchange({
              orRules: rules,
            })
          }
          shouldShowAutocomplete={this.props.shouldShowAutocomplete}
          shouldEnableFourComparison={this.props.shouldEnableFourComparison}
        />
      </React.Fragment>
    )
  }
}

InnerAudienceRuleForm.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      field_type: PropTypes.string,
    }).isRequired
  ),
  rules: PropTypes.array,
  onChange: PropTypes.func,
  shouldShowAutocomplete: PropTypes.bool,
}

InnerAudienceRuleForm.defaultProps = {
  rules: [],
  onChange: () => {},
}

// eslint-disable-next-line react/prop-types
export const AudienceRuleForm = ({ rules, ...unhandledProps } = {}) => (
  <InnerAudienceRuleForm {...unhandledProps} rules={rules} key={rules ? hash(rules) : ''} />
)

export const convertStateAudienceRule = (rule) => {
  return { ...rule, extra: rule.field, field: rule.field.value }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/AudienceRuleForm/index.js